var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.3999 13.1004L1.62303 11.9848L2.0999 9.60039L2.5199 9.18039L2.50896 9.16289L2.59209 9.10602L9.05834 2.64195L9.7999 1.90039L10.5415 2.64195L11.8562 3.95664L12.5999 4.70039L11.8583 5.44195L5.39209 11.9082L5.33522 11.9913L5.31772 11.9804L4.8999 12.4004L2.51553 12.8773L1.3999 13.1004ZM3.06678 10.1188L2.73865 11.7616L4.38147 11.4335L4.57615 11.2388L4.74897 10.9785L4.07084 10.8101L3.76459 10.7335L3.68803 10.4273L3.51959 9.74914L3.25928 9.92195L3.06459 10.1166L3.06678 10.1188ZM9.75834 6.05883L8.44365 4.74414L4.37053 8.81508L4.63303 9.86727L5.68521 10.1298L9.75834 6.05883ZM8.29928 6.68664L6.19928 8.78664L5.9499 9.03383L5.45553 8.53945L5.70271 8.29227L7.80272 6.19227L8.0499 5.94289L8.54428 6.43727L8.29709 6.68445L8.29928 6.68664Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.6bab3739.svg";
export { ForwardRef as ReactComponent };